package org.example.project.screens_sys

import kotlinx.serialization.builtins.ListSerializer
import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.Json
import org.example.project.manager.LumaticaApiManager
import org.example.project.enginetabular.loadWithTabularFilters
import org.example.project.service.LoginService
import org.example.project.utils.All

object KundenverbrauchApi {
    private val json = Json {
        ignoreUnknownKeys = true
        encodeDefaults = false
    }

    suspend fun loadCompanies(): List<All> =
        decodeList(LumaticaApiManager.call("kundenverbrauch/companies"))
            .withoutInternalSystemCompanies()

    suspend fun loadAllDetails(): List<All> =
        decodeList(LumaticaApiManager.call("kundenverbrauch/details-all"))

    suspend fun loadVerbrauch(firmenId: String, monthKey: String): All? =
        decodeOne(LumaticaApiManager.call("kundenverbrauch/verbrauch/${apiPart(firmenId)}/${apiPart(monthKey)}"))

    suspend fun loadVerbrauchMonate(firmenId: String): List<All> =
        decodeList(LumaticaApiManager.call("kundenverbrauch/verbrauch-monate/${apiPart(firmenId)}"))

    suspend fun saveVerbrauchEntry(firmenId: String, monthKey: String, entryId: String, entry: All): All? =
        decodeOne(
            LumaticaApiManager.call(
                "kundenverbrauch/verbrauch-entry-save-json/${apiPart(firmenId)}/${apiPart(monthKey)}/${apiPart(entryId)}/${apiPart(json.encodeToString(All.AllNames.serializer(), entry))}"
            )
        )

    suspend fun deleteVerbrauchEntry(firmenId: String, monthKey: String, entryId: String): Boolean =
        LumaticaApiManager.call("kundenverbrauch/verbrauch-entry-delete/${apiPart(firmenId)}/${apiPart(monthKey)}/${apiPart(entryId)}")
            .contains("\"ok\":true")

    suspend fun loadModules(firmenId: String): List<All> =
        decodeList(LumaticaApiManager.call("kundenverbrauch/customer-modules/${apiPart(firmenId)}/false"))

    suspend fun searchAbrechnung(monthKey: String, filters: Map<String, String>): List<All> =
        decodeList(
            loadWithTabularFilters(
                "kundenverbrauch/abrechnung-tabular",
                filters,
                mapOf("monthKey" to monthKey)
            )
        ).withoutInternalSystemCompanies()

    suspend fun searchAbrechnungDetails(firmenId: String, monthKey: String, filters: Map<String, String>): List<All> =
        decodeList(
            loadWithTabularFilters(
                "kundenverbrauch/abrechnung-details-tabular",
                filters,
                mapOf("firmenId" to firmenId, "monthKey" to monthKey)
            )
        )

    suspend fun searchRechnungsMonate(firmenId: String, filters: Map<String, String>): List<All> =
        decodeList(
            loadWithTabularFilters(
                "kundenverbrauch/rechnung-monate-tabular",
                filters,
                mapOf("firmenId" to firmenId)
            )
        )

    suspend fun loadSupport(mode: String = "all"): List<All> =
        decodeList(
            LumaticaApiManager.call(
                "kundenverbrauch/support-list/${apiPart(mode)}/${apiPart(LoginService.getId())}/${apiPart(LoginService.getUser()?.firmenId.orEmpty())}"
            )
        )

    private fun decodeOne(raw: String): All? =
        runCatching { json.decodeFromString(All.AllNames.serializer(), raw) }.getOrNull()

    private fun decodeList(raw: String): List<All> =
        runCatching { json.decodeFromString(ListSerializer(All.AllNames.serializer()), raw) }.getOrDefault(emptyList())

    private fun apiPart(value: String): String =
        js("encodeURIComponent")(if (value.isBlank()) "~" else value) as String
}
